<dfm-navigation-bar
  [navigationItems]="navigationItems"
  logoPath="assets/images/fordesk.svg"
  miniLogoPath="assets/images/fordesk.svg"
  [isProfileShown]="true"
  [isSettingsButtonShown]="false"
  [isTimeFormatOptionsShown]="false"
  [isThemeOptionsShown]="false"
  [profileData]="profileData"
  (logout)="logout()"
  [additionalNavigationItems]="additionalNavigationItems">
  @if (isLoaderActive$$ | async) {
    <mat-progress-bar
      class="mat-progress-bar"
      mode="indeterminate"></mat-progress-bar>
  }
  <router-outlet></router-outlet>
</dfm-navigation-bar>
<ng-template #additionalNavigationItems>
  <div [formGroup]="form">
    <dfm-input-dropdown
      #tenants
      class="d-flex align-items-center ml-5 mt-1"
      [items]="selectableTenants"
      [showDescription]="false"
      placeholder="{{ 'Tenants' }}"
      size="sm"
      formControlName="tenant"></dfm-input-dropdown>
  </div>
</ng-template>
